import React from 'react';
import './Vision.css';

const Vision = () => {
  return (
    <section id="vision" className="vision-section">
      <div className="container">
        <div className="vision-card">
          <h2 className="section-title">Our <span className="gradient-text">Vision</span></h2>
          <p className="vision-text">
            We bridge the gap between complex technology and business growth.
            By equipping SMEs with next-generation digital tools, we transform
            ambitious ideas into robust, scalable realities built for tomorrow's economy.
          </p>
          <div className="win-message">
            <span>🚀 Shared Success • Shared Growth • We Win Together 🚀</span>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Vision;